// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"1865fd70","977":"cdf2e5eb"}[chunkId] + ".chunk.js";
};